<template>
  <el-tooltip
    :disabled="isDisabledTooltip"
    effect="light"
    placement="top"
    class="ui-date-picker"
    :class="{'is-hide-icon': hideIcon}"
  >
    <el-date-picker
      :value="value"
      v-bind="$attrs"
      :format="format"
      :prefix-icon="hideIcon ? null : undefined"
      :pickerOptions="pickerOptions"
      @input="onInput"
      @change="onChange"
      @focus="onFocus"
    />
    <template v-slot:content>
      {{contentTooltip}}
    </template>
  </el-tooltip>
</template>

<script>
export default {
  name: 'date-picker',
  props: {
    value: { required: true },
    format: { type: String, default: 'dd/MM/yyyy' },
    disabledTooltip: { type: Boolean, default: false },
    hideIcon: { type: Boolean, default: false }
  },
  computed: {
    isDisabledTooltip () {
      return !!(this.disabledTooltip || !this.value)
    },
    contentTooltip () {
      if (!this.value) return ''
      return this.$moment(this.value).format('LL')
    },
    pickerOptions () {
      return {
        firstDayOfWeek: 1,
        shortcuts: [{
          text: this.L10n('today'),
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }]
      }
    }
  },
  methods: {
    onInput (date) {
      this.$emit('input', this.prepareValue(date))
    },
    onChange (date) {
      this.$emit('change', this.prepareValue(date))
    },
    onFocus () {
      this.$emit('focus', ...arguments)
    },
    prepareValue (date) {
      let value = null
      if (date instanceof Date) {
        value = this.$moment(date).format('YYYY-MM-DDT00:00:00')
      }
      return value
    }
  }
}
</script>
<style lang="stylus">
  .ui-date-picker{
    &.is-hide-icon {
      &.el-date-editor.el-input{
        .el-input__prefix{
          display none
        }
      }
    }
  }
</style>
